export const BRAND = {
  name: 'FindYourMUA',
  domain: 'FindYourMUA.co',
  tagline: 'Your one-stop destination to discover verified makeup artists.',
  whatsapp: '+91 8860768760',
  whatsappRaw: '918860768760',
  email: 'contact@findyourmua.com',
  logo: 'https://customer-assets.emergentagent.com/job_b5639216-ef24-4066-857b-6bd371205041/artifacts/juqcdipt_my%20%281%29.png',
  artistRegistrationUrl: 'https://docs.google.com/forms/d/e/1FAIpQLSd6XyDPr_K95PC484JXFIkdjo1bxIJHqwJGh7y-p5ZKPL_NXA/viewform?usp=dialog',
};

export const waLink = (msg = '') =>
  `https://wa.me/${BRAND.whatsappRaw}${msg ? `?text=${encodeURIComponent(msg)}` : ''}`;

// Treat known placeholder hosts (e.g. picsum.photos) and empty values as
// "no image", so stale auto-generated placeholders never render as a real
// artist photo. Falls through to the next available real image instead.
const PLACEHOLDER_HOSTS = ['picsum.photos'];
export const cleanImageUrl = (url) => {
  if (!url || typeof url !== 'string') return '';
  if (PLACEHOLDER_HOSTS.some(h => url.includes(h))) return '';
  return url;
};
export const cleanImageList = (arr) =>
  Array.isArray(arr) ? arr.filter(u => cleanImageUrl(u)) : [];

export const CATEGORIES = [
  {
    key: 'bridal',
    title: 'Bridal',
    sub: 'Once-in-a-lifetime glam',
    image: 'https://images.pexels.com/photos/11742213/pexels-photo-11742213.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900',
  },
  {
    key: 'engagement',
    title: 'Engagement',
    sub: 'Soft & luminous',
    image: 'https://images.unsplash.com/photo-1673413348184-102e17df237c?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  },
  {
    key: 'haldi-mehendi',
    title: 'Haldi / Mehendi',
    sub: 'Sun-kissed & festive',
    image: 'https://images.pexels.com/photos/13802704/pexels-photo-13802704.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900',
  },
  {
    key: 'roka',
    title: 'Roka',
    sub: 'Quietly radiant',
    image: 'https://images.unsplash.com/photo-1673413350047-ea5c0fd58c9e?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  },
  {
    key: 'party',
    title: 'Party',
    sub: 'Effortless glow',
    image: 'https://images.unsplash.com/photo-1630663124437-382b3831e7d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  },
  {
    key: 'editorial',
    title: 'Editorial',
    sub: 'Magazine-worthy moments',
    image: 'https://images.pexels.com/photos/32309583/pexels-photo-32309583.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900',
  },
  {
    key: 'sfx',
    title: 'SFX',
    sub: 'Experimental & avant-garde',
    image: 'https://images.unsplash.com/photo-1644134395029-d68dd6b97761?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  },
];

export const HERO_IMAGES = [
  'https://images.pexels.com/photos/36519701/pexels-photo-36519701.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=1900',
  'https://images.unsplash.com/photo-1740674570349-1fad9be37801?crop=entropy&cs=srgb&fm=jpg&q=85&w=1900',
  'https://images.pexels.com/photos/32309583/pexels-photo-32309583.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=1900',
  'https://images.pexels.com/photos/11742213/pexels-photo-11742213.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=1900',
];

export const BOOKING_JOURNEY = [
  { n: '01', t: 'Discover Your Perfect Artist', d: 'Browse carefully curated makeup artists by city, occasion, makeup style, budget, reviews, and availability — while exploring real portfolios to find your perfect match.' },
  { n: '02', t: 'Shortlist or Share Your Requirements', d: 'Found an artist you love? Let us know, and we\u2019ll help you take the next step. Need help deciding? Share your occasion, venue, budget, ready time, and inspiration images — we\u2019ll help you discover the best matches.' },
  { n: '03', t: 'Artist Consultation', d: 'Connect with your selected artist to discuss your desired look, preferences, trial requirements, and event details.' },
  { n: '04', t: 'Availability Confirmation', d: 'Your chosen artist confirms availability and booking details for your special day.' },
  { n: '05', t: 'Secure Your Booking', d: 'Pay a 10% advance to lock your date, with clear payment milestones for complete transparency.' },
  { n: '06', t: 'Get Glam-Ready', d: 'Your booking is confirmed. Relax knowing your beauty look is in trusted hands while we stay on standby till your big day.' },
];

export const FILTER_CITIES = [
  { value: 'Delhi', label: 'Delhi' },
  { value: 'Gurugram', label: 'Gurugram' },
  { value: 'Noida', label: 'Noida' },
  { value: 'Delhi NCR', label: 'Delhi NCR' },
];

export const FILTER_OCCASIONS = [
  'Bridal',
  'Engagement',
  'Haldi / Mehendi',
  'Roka',
  'Party',
  'Editorial',
  'SFX',
];

export const FILTER_BUDGETS = [
  { label: 'Under ₹10,000', min: 0, max: 10000 },
  { label: '₹10,000 – ₹20,000', min: 10000, max: 20000 },
  { label: '₹20,000 – ₹40,000', min: 20000, max: 40000 },
  { label: '₹40,000+', min: 40000, max: null },
];

export const FILTER_PRODUCT_KITS = [
  {
    value: 'luxury',
    label: 'Luxury Products',
    note: 'Charlotte Tilbury, Dior, NARS, Rare Beauty, Huda Beauty, MAC, Laura Mercier, Too Faced, ABH',
  },
  {
    value: 'mixed',
    label: 'Mixed Kit',
    note: 'A blend of luxury + professional products',
  },
  {
    value: 'affordable',
    label: 'Affordable Kit',
    note: 'PAC, Kryolan, Forever52, L\u2019Or\u00e9al, Maybelline, e.l.f, Swiss Beauty, Mars',
  },
];

export const FILTER_TIERS = [
  { value: 'rising', label: 'Rising Artist' },
  { value: 'popular', label: 'Popular Artist' },
  { value: 'premium', label: 'Premium Artist' },
];

export const FILTER_RATINGS = [
  { value: 4.0, label: '4.0 & above' },
  { value: 4.5, label: '4.5 & above' },
  { value: 4.8, label: '4.8 & above' },
];

export const SORT_OPTIONS = [
  { value: '', label: 'Best Match' },
  { value: 'price_desc', label: 'Price: High to Low' },
  { value: 'price_asc', label: 'Price: Low to High' },
  { value: 'recent', label: 'Recently Added' },
  { value: 'social', label: 'Social Credibility' },
];

export const OCCASIONS = ['Bridal', 'Engagement', 'Haldi / Mehendi', 'Roka', 'Party', 'Editorial', 'SFX', 'Reception', 'Other'];
export const BUDGETS = ['Under ₹10,000', '₹10,000 – ₹20,000', '₹20,000 – ₹40,000', '₹40,000+'];
export const STYLES = ['Soft Glam', 'HD', 'Airbrush', 'Traditional', 'Editorial', 'Dewy/Natural', 'Bold/Statement'];
export const READY_TIMES = ['Pre-dawn (before 6 AM)', 'Morning (6 – 9 AM)', 'Late morning (9 AM – 12 PM)', 'Afternoon', 'Evening'];
